import { Table } from "../../../../molecules/Table"
import intl from "react-intl-universal"
import styles from "./index.module.scss"

export const EquipmentAtention = ({ dataEquipmentAtention }) => {
  const columnsGrid = {
    gridTemplateColumns:
      dataEquipmentAtention?.length <= 2
        ? "grid-template-rows: 50vh;"
        : " grid-template-rows: repeat(2, 50vh);",
  }

  function isOdd(number) {
    return number % 2 !== 0
  }

  return (
    <div className={styles.wrapperEquipmentAtention}>
      <h2>Pontos de Atenção em Equipamentos</h2>
      <div className={styles.containerEquipmentAtention} style={columnsGrid}>
        {dataEquipmentAtention?.map((item) => {
          const attention_points_quantitative = item.attention_points.map((point) => {
            if (point.ecompliance === null) {
              return {
                anlt_nid: point.anlt_nid,
                eqpanltrun_nid: point.eqpanltrun_nid,
                analyte: point.anlt_cname,
                number_launch: `N˚${point.eqpanltrun_number}`,
                pendences:
                  point.eaction.includes("A") && point.eaction.includes("R")
                    ? `${intl.get("ciq.alert")} e ${intl.get("ciq.rejection")}`
                    : point.eaction.includes("A")
                    ? intl.get("ciq.alert")
                    : intl.get("ciq.rejection"),
              }
            } else {
              return {
                anlt_nid: point.anlt_nid,
                eqpanltrun_nid: point.eqpanltrun_nid,
                analyte: point.anlt_cname,
                number_launch: `N˚${point.eqpanltrun_number}`,
                pendences:
                  point.ecompliance === "N"
                    ? intl.get("ciq.not_according")
                    : intl.get("ciq.according"),
              }
            }
          })

          return (
            <div key={item.equipment_nid} className={styles.equipmentTable}>
              <h3>{item.equipment_cname}</h3>

              <Table
                bEdit={false}
                cursorNormal
                thead={[
                  intl.get("ciq.exame_analytes"),
                  intl.get("ciq.launch_run"),
                  intl.get("ciq.pendencies"),
                ]}
                tbodyArray={attention_points_quantitative}
              />
            </div>
          )
        })}
        {isOdd(dataEquipmentAtention?.length) && (
          <div className={`${styles.equipmentTable} ${styles.invisibleEquipmentTable}`}></div>
        )}
      </div>
    </div>
  )
}
